import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Agent Id',
    dataIndex: 'agentId',
    // render: (name, row) => (
    //   <Link to={ROUTES.OPERATOR_EDIT.replace(':clientId', row.username)}>
    //     {name}
    //   </Link>
    // ),
    sorter: (a, b) => a.agentId.localeCompare(b.agentId)
  },
  {
    title: 'Interval Seconds',
    dataIndex: 'config.agent.rollup.intervalSeconds',
    sorter: (a, b) => a.config.agent.rollup.intervalSeconds.localeCompare(b.config.agent.rollup.intervalSeconds)
  }
]

const ListView = ({ agents }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {agents.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {agents.length} agents
      </PageContentUnderTitle>
    )}
    <Table dataSource={agents} columns={columns} pagination={false} rowKey="agentId" />
  </div>
)

export default ListView



// WEBPACK FOOTER //
// ./src/pages/agent/agent-list/components/list-view/index.js